import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TaxRateShiftsDto } from '../dtos';
import { ITaxRateShiftsFeature } from './taxrate-shifts.feature.state';
import { getFailures, getIsLoading, getTaxRateShifts } from './taxrate-shifts.selectors';

@Injectable()
export class TaxRateShiftsFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public failures$ = this.store.select(getFailures);
  public taxrateShifts$ = this.store.select(getTaxRateShifts);

  constructor(private store: Store<ITaxRateShiftsFeature>) {}

  public getTaxRateShiftById(taxRateShiftId: number): Observable<TaxRateShiftsDto> {
    return this.taxrateShifts$.pipe(map((dictionary) => dictionary[taxRateShiftId]));
  }
}
